import React from 'react'
import { UserOutlined } from '@ant-design/icons'

import { SIZE } from '@app/constants'

import { LntAvatar } from '@app/components/base'
import { Show } from '@app/components/util'

import styles from './styles.module.scss'

import type { UserInfoProps } from './types'

export const UserInfo: React.FC<UserInfoProps> = props => {
  const { name, role, editorName } = props

  return (
    <div className={ styles.user }>
      <LntAvatar size={ SIZE.small }>
        <UserOutlined />
      </LntAvatar>
      <div className={ styles.user__info }>
        <div className={ styles.user__authorInfo }>
          <span className={ styles.user__authorName }> { name } </span>
          <Show condition={ !!role }>
            <span className={ styles.user__authorPosition }> { role } </span>
          </Show>
        </div>
        <Show condition={ !!editorName }>
          <span className={ styles.user__editor }>изменил(а) { editorName }</span>
        </Show>
      </div>
    </div>
  )
}
